import { ISPSubscriptionPlan, TenantTypeName } from "@core/types";

export const ISP_SUSCRIPTION_PLAN: ISPSubscriptionPlan[] = [
    {
        planName: TenantTypeName.ISP,
        description: "Ideal for businesses needing essential device management.",
        pricePrefix: "$",
        cycleType: "/ month",
        cycleSubDescription: "From",
        features: [
            {
                featureName: "Proactive Notifications",
                isAvailable: false,
                isStarAdded: false
            },
            {
                featureName: "Remote GUI Access",
                isAvailable: false,
                isStarAdded: false
            },
            {
                featureName: "Thirdy-Party Integrations",
                isAvailable: false,
                isStarAdded: false
            }
        ],
        buttonText: "Choose Standard",
        licensePackPrice: {
            "ISP-MO-100LP": 125,
            "ISP-MO-200LP": 175,
            "ISP-MO-300LP": 250,
            "ISP-MO-400LP": 300,
            "ISP-MO-500LP": 350,
            "ISP-MO-1KLP": 400,
            "ISP-MO-2KLP": 600,
            "ISP-MO-3KLP": 750,
            "ISP-MO-4KLP": 800,
            "ISP-MO-5KLP": 850,
            "ISP-MO-6KLP": 900,
            "ISP-MO-7KLP": 950,
            "ISP-MO-8KLP": 1000,
            "ISP-MO-9KLP": 1150,
            "ISP-MO-10KLP": 1250,
            "ISP-MO-11KLP": 1350,
            "ISP-MO-12KLP": 1450,
            "ISP-MO-13KLP": 1550,
            "ISP-MO-14KLP": 1650,
            "ISP-MO-15KLP": 1750,
            "ISP-MO-16KLP": 1850,
            "ISP-MO-17KLP": 1950,
            "ISP-MO-18KLP": 2050,
            "ISP-MO-19KLP": 2150,
            "ISP-MO-20KLP": 2250,
            "ISP-MO-21KLP": 2350,
            "ISP-MO-22KLP": 2450,
            "ISP-MO-23KLP": 2550,
            "ISP-MO-24KLP": 2650,
            "ISP-MO-25KLP": 2750,
            "ISP-MO-30KLP": 3250,
            "ISP-MO-40KLP": 4250,
            "ISP-MO-50KLP": 5250
        }
    },
    {
        planName: TenantTypeName.ISP_PLUS,
        description: "Built for growing businesses with alerts, notifications, and remote GUI.",
        pricePrefix: "$",
        cycleType: "/ month",
        cycleSubDescription: "From",
        features: [
            {
                featureName: "Proactive Notifications",
                isAvailable: true,
                isStarAdded: true
            },
            {
                featureName: "Remote GUI Access",
                isAvailable: true,
                isStarAdded: true
            },
            {
                featureName: "Thirdy-Party Integrations",
                isAvailable: false,
                isStarAdded: false
            }
        ],
        buttonText: "Upgrade to Plus",
        isPopular: true,
        licensePackPrice: {
            "ISP-MO-100LP": 150,
            "ISP-MO-200LP": 225,
            "ISP-MO-300LP": 300,
            "ISP-MO-400LP": 375,
            "ISP-MO-500LP": 420,
            "ISP-MO-1KLP": 480,
            "ISP-MO-2KLP": 720,
            "ISP-MO-3KLP": 900,
            "ISP-MO-4KLP": 960,
            "ISP-MO-5KLP": 1020,
            "ISP-MO-6KLP": 1080,
            "ISP-MO-7KLP": 1140,
            "ISP-MO-8KLP": 1200,
            "ISP-MO-9KLP": 1380,
            "ISP-MO-10KLP": 1500,
            "ISP-MO-11KLP": 1700,
            "ISP-MO-12KLP": 1800,
            "ISP-MO-13KLP": 1900,
            "ISP-MO-14KLP": 2000,
            "ISP-MO-15KLP": 2100,
            "ISP-MO-16KLP": 2200,
            "ISP-MO-17KLP": 2300,
            "ISP-MO-18KLP": 2400,
            "ISP-MO-19KLP": 2500,
            "ISP-MO-20KLP": 2600,
            "ISP-MO-21KLP": 2700,
            "ISP-MO-22KLP": 2800,
            "ISP-MO-23KLP": 2900,
            "ISP-MO-24KLP": 3000,
            "ISP-MO-25KLP": 3100,
            "ISP-MO-30KLP": 4100,
            "ISP-MO-40KLP": 5100,
            "ISP-MO-50KLP": 6100
        }
    },
    {
        planName: TenantTypeName.ISP_PRO,
        description: "Designed for advanced automation and third-party integrations.",
        extraFee: 6000,
        extraFeePerMonth: 500,
        pricePrefix: "+$",
        cycleType: "/ year",
        cycleSubDescription: "(Pro Add-on)",
        features: [
            {
                featureName: "Plus Plan Features",
                isAvailable: true,
                isStarAdded: false
            },
            {
                featureName: "API Access",
                isAvailable: true,
                isStarAdded: true
            },
            {
                featureName: "Webhooks Automation",
                isAvailable: true,
                isStarAdded: true
            }
        ],
        buttonText: "Unlock Pro Features",
        licensePackPrice: {
            "ISP-MO-100LP": 150,
            "ISP-MO-200LP": 225,
            "ISP-MO-300LP": 300,
            "ISP-MO-400LP": 375,
            "ISP-MO-500LP": 420,
            "ISP-MO-1KLP": 480,
            "ISP-MO-2KLP": 720,
            "ISP-MO-3KLP": 900,
            "ISP-MO-4KLP": 960,
            "ISP-MO-5KLP": 1020,
            "ISP-MO-6KLP": 1080,
            "ISP-MO-7KLP": 1140,
            "ISP-MO-8KLP": 1200,
            "ISP-MO-9KLP": 1380,
            "ISP-MO-10KLP": 1500,
            "ISP-MO-11KLP": 1700,
            "ISP-MO-12KLP": 1800,
            "ISP-MO-13KLP": 1900,
            "ISP-MO-14KLP": 2000,
            "ISP-MO-15KLP": 2100,
            "ISP-MO-16KLP": 2200,
            "ISP-MO-17KLP": 2300,
            "ISP-MO-18KLP": 2400,
            "ISP-MO-19KLP": 2500,
            "ISP-MO-20KLP": 2600,
            "ISP-MO-21KLP": 2700,
            "ISP-MO-22KLP": 2800,
            "ISP-MO-23KLP": 2900,
            "ISP-MO-24KLP": 3000,
            "ISP-MO-25KLP": 3100,
            "ISP-MO-30KLP": 4100,
            "ISP-MO-40KLP": 5100,
            "ISP-MO-50KLP": 6100
        }
    }
];